import './Icon_Arrow_Down.css';
 
function Icon_Arrow_Down() {
  return (
   
      <div className='icon-container-arrow-down'>
          <svg viewBox="0 0 24 24" className="arrow-down-svg">
              <path d="m6 10 6 6 6-6"/>
          </svg>
      </div>
           
  );
}
 
export default Icon_Arrow_Down;
//<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down-icon lucide-chevron-down"><path d="m6 9 6 6 6-6"/></svg>